import { render, staticRenderFns } from "./bimTable.vue?vue&type=template&id=21205896&scoped=true&lang=html&"
import script from "./bimTable.vue?vue&type=script&lang=js&"
export * from "./bimTable.vue?vue&type=script&lang=js&"
import style0 from "./bimTable.vue?vue&type=style&index=0&id=21205896&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21205896",
  null
  
)

export default component.exports